const shouldUseCaching = (praType) => {
    return !!praType && ['SWG', 'PRA1'].indexOf(praType) > -1;
};
export default shouldUseCaching;
//# sourceMappingURL=shouldUseCaching.js.map